// project import
import Navigation from './Navigation';
import SimpleBar from 'components/third-party/SimpleBar';

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = () => {
  return (
    <SimpleBar
      sx={{
        height: 'inherit',
        backgroundColor: '#3d2260',
        marginTop: '9px',
        '& .simplebar-content': {
          display: 'flex',
          flexDirection: 'column',
          whiteSpace: 'initial'
        }
      }}
    >
      <Navigation />
    </SimpleBar>
  );
};

export default DrawerContent;
